<script setup>
import {onMounted} from "vue";
import {useUserStore} from "@/stores/user.js";

const userStore = useUserStore();
const fetchInitialData = async () => {
  const res = await userStore.action_getPartialProfile3({id: 1})
  console.log(res)
}
onMounted(() => {
  fetchInitialData()
})
</script>

<template>
  <p>test</p>
</template>

<style scoped lang="scss">

</style>